@if (actionSection) {
  <div class="is-taller nav-padding">
    <div class="level">
      <div class="level-item">
        @if (!firstSection) {
          <button type="button" class="bofa--button secondary outlined ui-font"
          (click)="onClickPrevious()">Previous step</button>
        }
      </div>
      @if (!firstSection && !formSubmitted) {
        <div class="level-region level-nav">
          <button type="button" class="bofa--button secondary dark-blue save-ie save-margin ui-font save-height"
          (click)="onClickSave()">Save</button>
          <button type="button" class="bofa--button secondary outlined ui-font"
            (click)="onClickSaveAndFinishLater()">Save
          and finish later</button>
        </div>
      }
      <div class="level-item level-nav">
        @if (!firstSection && !lastSection && !formSubmitted) {
          <button type="button" class="bofa--button secondary no-margin-right dark-blue large ui-font font-size"
            (click)="onClickNext()">Save and
          continue</button>
        }
        @if (!firstSection && !lastSection && formSubmitted) {
          <button type="button" class="bofa--button secondary no-margin-right dark-blue large"
          (click)="onClickNext()">Next</button>
        }
      </div>
      <div class="level-item">
        @if (firstSection) {
          <button type="button" class="bofa--button secondary dark-blue large"
          (click)="onClickNext()">Start</button>
        }
      </div>
      @if (lastSection && !formSubmitted) {
        <div class="level-item">
          <button type="button" (click)="onClickNext()" class="bofa--button primary large ui-font">Save and
          submit</button>
        </div>
      }
    </div>
  </div>
}